import React from 'react';
import PropTypes from 'prop-types';

/**
 * CardHeaderIcon - A wrapper that renders a standard HTML div element with Bulma card-header-icon class names
 * 
 * This component accepts the same props as Bloomer CardHeaderIcon for easy migration
 */
const CardHeaderIcon = ({
  className,
  style,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['card-header-icon'];
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <div 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

CardHeaderIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

CardHeaderIcon.defaultProps = {
  className: '',
  style: {},
  children: null
};

export default CardHeaderIcon;
